import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./slider.css"
import Img from "gatsby-image"
import styled from "@emotion/styled"

const SimpleSlider = props => {
  const { images } = props
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    focusOnSelect: true,
  }

  const StyledImg = styled(Img)`
    border: 1px solid lightgrey;
    border-radius: 2px;
    width: 600px;
    max-height: 500px;
    height: auto;
  `

  return (
    <Slider {...settings}>
      {images.map(i => (
        <div>
          <StyledImg fluid={i.fluid} />
        </div>
      ))}
    </Slider>
  )
}

export default SimpleSlider
